import React from 'react';

const Issues: React.FC = () => {
  return <div>Issues Management</div>;
};

export default Issues;
